import React from "react";
import "./visionView.css";
import Heading from "../Heading";
import "animate.css/animate.min.css";
import ScrollAnimation from "react-animate-on-scroll";

const icon1 = "https://winpeforum.com/assets/elements/vision3.png";
const icon2 = "https://winpeforum.com/assets/elements/vision1.png";
const icon3 = "https://winpeforum.com/assets/elements/vision2.png";

export class Vision extends React.Component {
  constructor(args) {
    super(args);
    this.state = {};
    this.Partners = [
      {
        imgUrl: icon1,
        text: "#Engage",
        subText:
          "Engage with firms within the investing ecosystem and their decision makers in a constructive and open dialogue on the opportunities of gender diversity with an intent to drive collective action on a mutual agenda.",
      },
      {
        imgUrl: icon2,
        text: "#Empower",
        subText:
          "Empower the women who are part of the investing industry with a set of training, networking and mentoring resources designed to help them thrive and succeed.",
      },
      {
        imgUrl: icon3,
        text: "#Enhance",
        subText:
          "Enhance the participation of female talent in the investing ecosystem, foster an environment and working practices make it an attractive career option for women.",
      },
    ];
  }
  render() {
    return (
      <div className="section__content">
        <div className="vision__wrapper">
          <div className="vision__section">
            <div className="vision_content">
              <div className="left_section">
                <div className="left_content">
                  <div className="left_text">
                    <ScrollAnimation
                      delay={0}
                      duration={2}
                      animateIn="zoomIn"
                      offset={300}
                    >
                      <div className="winpe__quotes">
                        <span className="">
                          <i
                            className="fa fa-quote-left"
                            aria-hidden="true"
                          ></i>
                        </span>
                        <span>
                          {" "}
                          Gender diversity within the investing ecosystem is
                          within the influence of each constituent of this
                          ecosystem and the change that Winpe aims to catalyse
                          is best led by these constituents.{" "}
                        </span>
                        <span style={{ Verticalalign: "top" }}>
                          <i
                            className="fa fa-quote-right"
                            aria-hidden="true"
                          ></i>
                        </span>
                      </div>
                    </ScrollAnimation>
                  </div>
                  <div className="left_subtext"></div>
                </div>
              </div>
              <div className="right_section">
                <ScrollAnimation
                  delay={0}
                  duration={2}
                  animateIn="slideInRight"
                  offset={600}
                >
                  <div className="right_content">
                    <div className="low__heading"></div>
                    <div className="">
                      <Heading title="The Winpe Vision" />
                    </div>
                    <div className="right_text">
                      Winpe believes change can only be witnessed when we
                      combine dialogue with action. Based on this philosophy,
                      Winpe engages with the leaders and influencers to drive
                      culture change, while providing a suite of powerful
                      resources to support women who are part of this industry
                      or who aspire to be.
                    </div>
                    <div className="rightPoint_secton">
                      <div className="row">
                        {this.Partners.map((item, i) => {
                          return (
                            <div className="point_box" key={i}>
                              <div className="point_text">{item.text}</div>
                              <div className="subText">{item.subText}</div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>

                  <div className="vision__buttons">
                    <a
                      href="/winpecharter/"
                      className="vision__buttons__button"
                    >
                      Winpe Charter
                    </a>
                    <a
                      className="vision__buttons__button"
                      href="/membermanifesto/"
                    >
                      Winpe Member Manifesto
                    </a>
                  </div>
                </ScrollAnimation>
              </div>
            </div>
          </div>
          <div className="section_divider1">
            <img
              src="https://winpeforum.com/assets/elements/Section_divier_gray.png"
              width="100%"
              alt=""
              className="img-responsive"
            />
          </div>
          <div className="section_divider">
            <img
              src="https://winpeforum.com/assets/elements/phone_section_divider.png"
              width="100%"
              alt=""
              className="img-responsive"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Vision;



// WEBPACK FOOTER //
// ./src/components/vision/index.js